import { render, staticRenderFns } from "./universiadeFull_WUSG.vue?vue&type=template&id=fa0d93a8"
import script from "./universiadeFull_WUSG.vue?vue&type=script&lang=js"
export * from "./universiadeFull_WUSG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports